import { decrypt } from "@repo/shared-utils/crypto";

export interface ILocalStorageData {
  rK: string;
  rD: string;
  key: string;
}

export interface IAppSdkResponse {
  back: string;
  order_id: string;
  response: string;
}

declare global {
  interface Window {
    callDocumentCenterBase64: () => string;
    setCPRPaymentResponse: (res: IAppSdkResponse) => void;
    storeBase64Data: string;
  }
}

export const storeEncryptedResInLocalStorage = (props: ILocalStorageData) => {
  const reqObject = {
    rK: btoa(props.rK),
    rD: props.rD,
  };
  localStorage.setItem(props.key, JSON.stringify(reqObject));
};

export const readEncryptedResFromLocalStorage = async <T>(
  key: string,
): Promise<T | null> => {
  const localStorageData = localStorage.getItem(key);
  if (localStorageData) {
    const { rK, rD } = JSON.parse(localStorageData);
    const decrpytedRes = await decrypt(rD, atob(rK));
    return decrpytedRes as T;
  }
  return null;
};
